// src/App.tsx
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTopButton from "@/components/ScrollToTopButton";
import Index from "./pages/Index";
import Module from "./pages/Module";
import Seminartermine from "./pages/Seminartermine";
import Preise from "./pages/Preise";
import Mehr from "./pages/Mehr";
import Anmeldung from "./pages/Anmeldung";
import Behandlungen from "./pages/Behandlungen";
import AGB from "./pages/AGB";
import Impressum from "./pages/Impressum";
import Kooperationen from "./pages/Kooperationen";
import Lebenswerkstaetten from "./pages/Lebenswerkstaetten";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Sonner />
      <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="grow">
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/module" element={<Module />} />
              <Route path="/seminartermine" element={<Seminartermine />} />
              <Route path="/preise" element={<Preise />} />
              <Route path="/mehr" element={<Mehr />} />
              <Route path="/anmeldung" element={<Anmeldung />} />
              <Route path="/behandlungen" element={<Behandlungen />} />
              <Route path="/agb" element={<AGB />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/kooperationen" element={<Kooperationen />} />
              <Route path="/lebenswerkstaetten" element={<Lebenswerkstaetten />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <ScrollToTopButton />
        </div>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;